export default "__VITE_ASSET__pTL52ze1__"